module.exports = __webpack_public_path__ + "static/media/pokedex.de16efdd.png";